import React, { useState, useEffect } from "react";
import { Form } from "@components";
import { GsapDetail } from "./detail";
import { GsapFilters } from "./types";
import { M_TABLE_HEADERS_GSAP } from "../constants";
import { Cell } from "@components/table/types";
import { Box, Button } from "@material-ui/core";
import { FilterType, Table } from "@components";
import api from "@api";
import { useGsapStore } from "../../../../../store/hooksy";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import { exportGsapSecurityRoles } from "@api/excel-exporters/exportGsapSecurityRoles";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_GSAP.SECURITY_ROLE },
  { data: M_TABLE_HEADERS_GSAP.ACCESS_TYPE },
  { data: M_TABLE_HEADERS_GSAP.IS_ACTIVE },
];

export const Gsap: React.FC = () => {
  const [gsapHooksyStore, setGsapHooksyStore] = useGsapStore();

  useEffect(() => {
    if (gsapHooksyStore.fetchList) {
      getDataList();
    }
  }, [gsapHooksyStore]);

  const form = Form.useManager<GsapFilters>({
    id: 0,
    securityRole: "",
    accessType: "",
    isActive: false,
  });

  const [openGasp, setOpenGasp] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedGsap, setSelectedGsap] = useState<GsapFilters>();
  const [gsapList, setGsapList] = useState([]);

  useEffect(() => {
    getDataList();
  }, []);

  useEffect(() => {
    if (openGasp) {
      if (selectedGsap) {
        form.set(Form.target.VALUE, ["id", selectedGsap.id]);
        form.set(Form.target.VALUE, [
          "securityRole",
          selectedGsap.securityRole,
        ]);
        form.set(Form.target.VALUE, ["accessType", selectedGsap.accessType]);
        form.set(Form.target.VALUE, ["isActive", selectedGsap.isActive]);
      }
    }
  }, [openGasp]);

  function getDataList() {
    api.gsap
      .getGsap()
      .then((response) => {
        setGsapList(response.gsap);
      })
      .catch((error) => {
        console.error(`Error in fetching gsap ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
        setGsapHooksyStore({ fetchList: false });
      });
  }

  function handleExport() {
    exportGsapSecurityRoles();
  }

  const isShowModal = openGasp ? (
    <GsapDetail
      form={form}
      open={openGasp}
      onCancel={() => setOpenGasp(false)}
    />
  ) : (
    ""
  );
  const pageName = "GSAP";
  return (
    <Box mt={2}>
      <MaintenanceBreadcrumbs title={pageName} />
      <Button style={{ float: "right" }} onClick={handleExport}>
        EXPORT TO EXCEL
      </Button>
      <Table
        data={gsapList.map((gsap: any) => ({
          cells: [
            {
              data: gsap.securityRole,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedGsap(gsap);
                setOpenGasp(true);
              },
            },
            {
              data: gsap.accessType,
            },
            {
              data: gsap.isActive ? "Yes" : "No",
            },
          ],
          data: gsap,
        }))}
        tableName={pageName}
        searchPlaceholder="Search by Name"
        searchColumns={[M_TABLE_HEADERS_GSAP.SECURITY_ROLE]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="M_GSAP_TOOLBAR"
        loading={isLoading}
      />
      {isShowModal}
    </Box>
  );
};
